<template>
	<div class="ertghj" :loading="loading">
		<p v-if="status!=1 && status!=4" v-bind:class="['osie',{'yellow':status===5 || status===2}]">{{ruleForm.stateDesc}}</p>
		<el-form 
			:model="ruleForm" 
			:rules="rules" 
			ref="ruleForm" 
			label-width="140px" 
			v-bind:class="{'no-star': ifEdit,'second-upload': picLength}">
		  <el-form-item label="企业名称" prop="orgName">
		    <el-input v-model="ruleForm.orgName" @blur="comBlur()" placeholder="请输入企业名称" :disabled="ifEdit" clearable></el-input>
		  </el-form-item>
		  <el-form-item label="统一社会信用代码" prop="usCreditCode">
		    <el-input v-model="ruleForm.usCreditCode" placeholder="企业社会统一信用代码" :disabled="ifEdit" clearable></el-input>
		  </el-form-item>
		  <el-form-item label="法定代表人" prop="legal">
		    <el-input v-model="ruleForm.legal" placeholder="企业法定代表人" :disabled="ifEdit" clearable></el-input>
		  </el-form-item>
		  <el-form-item label="联系地址" prop="address">
		    <el-input v-model="ruleForm.address" placeholder="联系地址" :disabled="ifEdit" clearable></el-input>
		  </el-form-item>
		  <el-form-item label="所在部门" prop="department">
		    <el-input v-model="ruleForm.department" placeholder="请输入所在部门" :disabled="ifEdit" clearable></el-input>
		  </el-form-item>
		  <el-form-item label="应用场景" prop="scene">
		  	<el-input type="textarea" v-model="ruleForm.scene" :disabled="ifEdit" auto-complete="off"></el-input>
		  </el-form-item>
		  <el-form-item label="认证到期时间" prop="expireTime">
		  	<el-input v-model="ruleForm.expireTime" placeholder="请输入认证到期时间" disabled clearable></el-input>
		  </el-form-item>
		  <el-form-item :label="status===1 || status===3 || !ifEdit?'上传营业执照':'企业材料'" prop="paper">
		  	<el-upload
			 :disabled="ifEdit"
			  :limit="num"
		  	  :action="uploadUrl"
		  	  list-type="picture-card"
		  	  :on-preview="handlePictureCardPreview"
			  :on-success="handlePictureSuccesss"
			  :headers="{'authorization': 'Bearer '+$store.state.token}"
			  :on-error="handlePictureFail"
			  :file-list="ruleForm.paper"
			  ref="upload"
			  :before-upload="handlePictureBefore"
			  accept="image"
		  	  :on-remove="handleRemove">
		  	  <i class="el-icon-plus"></i>
			  <span class="dewde"></span>
		  	</el-upload>
			<p class="dewde" v-if="!ifEdit">支持JPG、JPEG、PNG格式，大小不超过5M。</p>
		  	<el-dialog :visible.sync="dialogVisible">
		  	  <img width="100%" :src="dialogImageUrl" alt="">
		  	</el-dialog>
		  </el-form-item>
		  <el-form-item v-if="!ifEdit">
			  <el-checkbox v-model="checked">我已阅读并同意<router-link target="_blank" to="/aboutUs/case4?name=认证服务协议&id=3">《动态时序认证服务协议》</router-link></el-checkbox>
		  </el-form-item>
		  <el-form-item v-if="status===1">
			<el-button @click="resetForm('ruleForm')">取消</el-button>
		    <el-button type="primary" @click="submitForm('ruleForm')">提交认证</el-button>
		  </el-form-item>
		  <el-form-item v-if="status===3">
			<el-button @click="resetForm('ruleForm')">取消</el-button>
		    <el-button type="primary" @click="submitForm('ruleForm')">提交认证</el-button>
		  </el-form-item>
		  <el-form-item v-if="status===4">
		    <el-button type="primary" @click="submitForm('ruleForm')">更新认证</el-button>
		  </el-form-item>
		  <el-form-item v-if="status===5">
			<el-button @click="resetForm('ruleForm')">{{canEdit?'取消':'重新认证'}}</el-button>
		    <el-button type="primary" @click="submitForm('ruleForm')">{{canEdit?'提交认证':'再次审核'}}</el-button>
		  </el-form-item>
		  <!-- <el-form-item v-if="status!=2">
			<el-button v-if="status!=4" @click="resetForm('ruleForm')">{{status===5?'更新认证':'取消'}}</el-button>
		    <el-button type="primary" @click="submitForm('ruleForm')">{{status===1 || status===3?'提交认证':status===4?'更新认证':'再次审核'}}</el-button>
		  </el-form-item> -->
		</el-form>
		
		<el-dialog :visible.sync="waitPop" :show-close="false" width="400px">
			<div class="dwdwe">
				<h6>企业认证信息已提交，请等待审核...</h6>
				<p>提交后一个工作日内完成审核</p>
				<el-button type="primary" @click="close()">关闭</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="diffCompany" width="400px">
			<div class="oggss">
				<h6>认证企业名称与注册企业名称不一致<br/>是否继续认证？</h6>
				<p><span>认证企业名称：</span>{{ruleForm.orgName}}</p>
				<p><span>注册企业名称：</span>{{oldCompanyName}}</p>
				<div class="kgubs">
					<el-button type="plain" @click="rewirte()">重新填写</el-button>
					<el-button type="primary" @click="rewirte()">继续认证</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
  import { userApi, imageUploadUrl } from '@/api'

  export default {
    data() {
      return {
	    dialogImageUrl: '',
	    dialogVisible: false,
        ruleForm: {
          orgName: '',
          usCreditCode: '',
          legal: '',
          address: '',
          department: '',
          scene: '',
          img: '',
		  checked: false,
		  expireTime: '',
		  paper: []
        },
		oldCompanyName: '',
		checked: false,
		waitPop: false,
		diffCompany: false,
		status: 1,
		num: 1,
		loading: false,
		canEdit: false,
        rules: {
          orgName: [
            { required: true, message: '请输入企业名称', trigger: 'blur' },
			{ min: 6, max: 50, message: '长度在6-50个汉字', trigger: 'blur' }
          ],
          usCreditCode: [
            { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
          ],
		  legal: [
		    { required: true, message: '请输入法定代表人', trigger: 'blur' }
		  ],
		  address: [
		    { required: true, message: '请输入联系地址', trigger: 'blur' }
		  ],
		  department: [
		    { required: true, message: '请输入所在部门', trigger: 'blur' },
			{ min: 1, max: 10, message: '所在部门请输入10个汉字以内', trigger: 'blur' }
		  ],
		  scene: [
		    { required: true, message: '请输入应用场景', trigger: 'blur' }
		  ],
		  expireTime: [
		    { required: true, message: '', trigger: '' }
		  ],
		  paper: [
			{ required: true, message: '请上传工商营业执照', trigger: '' }  
		  ]
        },
		if_upload: false,
		picLength: false
      };
    },
	computed: {
		// 图片上传地址统一由 api 模块提供
		uploadUrl() {
			return imageUploadUrl
		},
		ifEdit() {
			if (this.canEdit) {
				return false
			} else {
				return this.status === 2 || this.status === 4 || this.status === 5
			}
		},
		// picLength() {
		// 	return this.ruleForm.paper && this.ruleForm.paper.length>0
		// }
		// picLength() { || this.status === 3
		// 	console.log(this.ruleForm.paper.length>0)
		// 	return this.ruleForm.paper.length>0
		// }
	},
	watch: {
		waitPop: function(newVal,oldVal) {
			if (newVal) {
				this.$store.commit('setOtherMeng',1)
			} else {
				this.$store.commit('setOtherMeng',0)
			}
		},
		diffCompany: function(newVal,oldVal) {
			if (newVal) {
				this.$store.commit('setOtherMeng',1)
			} else {
				this.$store.commit('setOtherMeng',0)
			}
		}
	},
	mounted() {
		this.getData()
		this.$store.commit('setCenterIndex',1)
	},
    methods: {
	  getOutTime() {
		 this.ruleForm.expireTime = (new Date().getFullYear()+10)+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate() 
	  },
	  comBlur() {
	  if(this.ruleForm.orgName.length>5) {
		  // 未登录时不再对 undefined 取 userId（旧实现在此抛错）；登录用户的请求口径不变
		  const user = this.$cookies.getJSON('user')
		  if (!user || !user.userId) return
		  this.loading = true
		  let params = {
				  userId: this.$cookies.getJSON('user').userId,
				  name	: this.ruleForm.orgName
			  }
			  userApi.getOrgBaseInfo(params)
			  .then((res) =>{
				  if (res.state===200) {
					this.ruleForm.usCreditCode = res.data.usCreditCode
					this.ruleForm.legal = res.data.legal
					this.oldCompanyName = res.data.regOrgName
					if (this.oldCompanyName!=this.ruleForm.orgName) {
						this.diffCompany = true
					}
				  } else if(res.state===400) {
						this.status=1
				  } else {
					this.$message.error(res.message);
				  }
				  this.loading = false
			  })
			  .catch(err=>{
				  this.$message.error(err);
				  this.loading = false
			  })
		  }
		  
	  },
	  handleRemove(file, fileList) {
		this.picLength = false
		this.ruleForm.paper = []
		console.log(this.ruleForm.paper.length)
	  },
	  handlePictureFail(err, file, fileList) {
		console.log(err, file, fileList)
		this.$message.error(err);  
	  },
	  handlePictureBefore(file) {
		 let str = file.name
		 if (str.indexOf('.jpg')>-1 || str.indexOf('.png')>-1 || str.indexOf('.jpeg')>-1) {
			 
		 } else {
			 this.$message.error('请上传JPG、JPEG、PNG格式的大小不超过5M的图片');
			 return false
		 }
		 let fileSize = file.size/1024 /1024
		 if (fileSize>5) {
			this.$message.error('请上传JPG、JPEG、PNG格式，大小不超过5M的图片');
			return false 
		 }
	  },
	  handlePictureCardPreview(file) {
	    console.log(file)
		this.dialogImageUrl = file.url;
		this.dialogVisible = true;
	  },
	  handlePictureSuccesss(file,fileList) {
		console.log(555)
		console.log(file,fileList)
		if (file.state===200 && file.data) {
			this.picLength = true
			this.ruleForm.paper[0] = file.data
		} else {
			this.$refs.upload.clearFiles();
			this.picLength = false
			this.ruleForm.paper = []
			this.$message.error(file.message); 
		}
	  },
      submitForm(formName) {
		// if() {
		// 	this.$message.success('');
		// }
		this.picLength = this.ruleForm.paper && this.ruleForm.paper.length>0
		if ([2,4].indexOf(this.status)>-1 && !this.canEdit) {
			this.canEdit = true
			this.getOutTime()
			return
		}
		if (this.status===4 && !this.canEdit) {
			this.getOutTime()
		}
        this.$refs[formName].validate((valid) => {
          if (valid) {
			  if (this.ruleForm.paper && this.ruleForm.paper.length===0) {
				this.$message.error('请上传工商营业执照');
				return
			  }
			  if (this.status===5 && !this.canEdit) {
				  this.getOutTime()
			  } else {
				  if (!this.checked) {
					this.$message.error('请阅读并勾选下方协议');
					return
				  }
			  }
			  
			 // if (this.oldCompanyName && this.oldCompanyName != this.ruleForm.orgName && !source) {
				// this.diffCompany = true
				// return
			 // }
			this.loading = true
           // 未登录时不提交（旧实现在此对 undefined 取 userId 抛错）；登录用户请求参数不变
           const user = this.$cookies.getJSON('user')
           if (!user || !user.userId) return
           let params = {
			  userId: this.$cookies.getJSON('user').userId,
			  orgName: this.ruleForm.orgName,
			  usCreditCode: this.ruleForm.usCreditCode,
			  legal: this.ruleForm.legal,
			  address: this.ruleForm.address,
			  department: this.ruleForm.department,
			  scene: this.ruleForm.scene,
			  expireTime: this.ruleForm.expireTime,
			  businessLicense: this.ruleForm.paper[0].url || this.ruleForm.paper[0],
			  goCert: 1,
			  orgId: this.ruleForm.orgId
			}
		   const request = this.status===1?userApi.submitOrgCert:userApi.updateOrgCert
           request(params)
			  .then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					this.waitPop = true
					this.getData()
				  } else if(res.state===400) {
					  this.status=1
				  } else {
					  this.$message.error(res.message);
				  }
				  
				  this.loading = false
			  })
			  .catch(err=>{
				  this.$message.error(err);
				  this.loading = false
			  })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
		if (this.status===5 && !this.canEdit) {
			this.canEdit = true
			this.picLength = this.ruleForm.paper.length>0
			this.getOutTime()
			return
		}
        this.$refs[formName].resetFields();
		window.history.go(-1);
      },
	  close() {
		this.waitPop = false  
	  },
	  rewirte() {
		 this.diffCompany = false 
	  },
	  gohead() {
		  this.diffCompany = false
		  this.submitForm()
	  },
	getData() {
		// 未登录时不请求认证信息（旧实现在此对 undefined 取 userId 抛错）；登录用户请求口径不变
		const user = this.$cookies.getJSON('user')
		if (!user || !user.userId) return
		let params = {
			  userId: this.$cookies.getJSON('user').userId
		}
		userApi.getOrgCertInfo(params)
		  .then((res) =>{
			  if (res.state===200) {
			      this.getOutTime()  
			  } else if(res.state===400) {
				  this.getOutTime()
				  this.status=1
			  } else {
				  this.$message.error(res.message);
			  }
			 this.ruleForm['stateDesc'] =  res.message
			 try{
				if(res.data) {
					this.status = res.data.state
					this.ruleForm = res.data
					this.oldCompanyName = res.data.orgName
					if (res.data.businessLicense) {
						this.ruleForm['paper'] = [
						  {name: 'result@2.png',url: res.data.businessLicense}
						]
						this.picLength = true
					}
				}
			 }catch(e){
			 	//TODO handle the exception
			 }
		  })
		  .catch(err=>{
			  this.$message.error(err);
		  })  
	  }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/center/caseChild/case2.vue